import { z } from 'zod';
import { isoDateTime } from './common';

export const adminRoleSchema = z.enum(['owner', 'editor']);
export type AdminRole = z.infer<typeof adminRoleSchema>;

export const adminSchema = z.object({
  uid: z.string(),
  email: z.string().email(),
  displayName: z.string(),
  role: adminRoleSchema,
  createdAt: isoDateTime,
});
export type Admin = z.infer<typeof adminSchema>;
